module.exports = __webpack_public_path__ + "img/881.7df9567b.png";